import React, { Fragment } from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { catalogProductClicked } from "../../actions/ui"
import { closeCartWidget } from '../../actions/general';
import { 
    getSelectedFabricValues, 
    recalculateShirtPrice,
} from '../../selectors/entities/general'
import { isAddedToCart } from '../../selectors/entities/users';
import { getActiveDetailsPreset } from '../../selectors/entities/ui';

import ProductCanvasList from '../ProductCanvasList';
import Widget from '../ProductWidget';

class ProductList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    shouldComponentUpdate = (props, state) => {
        return this.props.selectedFabric !== props.selectedFabric ||
            this.state.isMobile !== state.isMobile ||
            this.props.showWidget !== props.showWidget;
    }

    render() {
        const  {
            selectedFabric,
            showWidget,
            price,
            activePreset,
            isMobile,
            actions: { closeCartWidget },
        } = this.props;

        return (
            <Fragment>
                <Widget
                    show={showWidget}
                    price={price}
                    fabric={selectedFabric.displayName}
                    type={'catalog'}
                    isMobile={isMobile}
                    onClose={closeCartWidget}
                    article={selectedFabric.article}
                    preset={activePreset}
                />
                <ProductCanvasList />
            </Fragment>
        )
    }
}

ProductList.propTypes = {
    selectedFabric: PropTypes.object.isRequired,
    showWidget: PropTypes.bool.isRequired,
    price: PropTypes.number.isRequired,
    activePreset: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    const selectedFabric = getSelectedFabricValues(state)
    const showWidget = isAddedToCart(state);
    const price = recalculateShirtPrice(state);
    const activePreset = getActiveDetailsPreset(state);
    const isMobile = state.ui.isMobile;

    return {
        selectedFabric,
        showWidget,
        price,
        activePreset,
        isMobile,
        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
        catalogProductClicked,
        closeCartWidget,
    }, dispatch)
  };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(ProductList));